<div class="not-found-page">
  <h1 class="not-found-page-title">{{ i18n.t('notFound.title') }}</h1>
  <p class="not-found-page-message">{{ i18n.t('notFound.description') }}</p>
  <a class="not-found-page-link" routerLink="/en/ima">{{ i18n.t('notFound.goHome') }}</a>
</div>
